__turbopack_context__.v({
  "className": "font_b1b8b971-module__4YNL8q__className",
});
